import { createStore } from 'vuex'

export default createStore({
  state: { organizer: { name: 'Jack' } },
  mutations: {},
  actions: {},
  modules: {}
})
